
  import { IEmailSentModel } from "@/models";
  import { BlackListService } from "@/services/admin";
  import { Component, Emit, Vue } from "vue-property-decorator";

  @Component({
    name: "UserComment",
    components: {}
  })
  export default class UserComment extends Vue {
    @Emit("onBack")
    onBack() {}
    isLoading: boolean = false;

    fields: any[] = [
      {
        tdClass: "short-column",
        key: "emailTo",
        label: "Email To"
      },
      {
        key: "comments",
        label: "Comments"
      }
    ];
    items: IEmailSentModel[] = [];

    backToMainView() {
      this.onBack();
    }

    async onLoad(email: string) {
      this.items = [];
      this.isLoading = true;
      var response = await BlackListService.GetUserComment(email);
      if (response.status === 200) {
        this.items = response.data;
      } else {
        this.generateError("Failed to load user comments");
      }
      this.isLoading = false;
    }

    generateError(msg: string) {
      this.$bvToast.toast(`Error: ${msg}`, {
        title: "Error",
        variant: "danger",
        autoHideDelay: 5000
      });
    }
  }
